import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../BaseUrl/baseurl";
import axios from "axios";

const token = localStorage.getItem("token");

// console.log("token",token)

export const getPennyTransactionList = createAsyncThunk(
    "getTransactionList",

    async id => {
        // console.log("what is id befor fetch", id);
        const response = await axios.get(
            `${baseUrl}/book/getpannytransaction/${id}`,
            {
                headers: {
                    authorization: token
                }
            }
        );
        // console.log("transaction listss", response.data.data);
        return response.data.data;
    }
);

export const getBookingTransactionList = createAsyncThunk(
    "getBookingTransactionList",
    async id => {
        // console.log("what is id befor fetch", id);
        const response = await axios.get(
            `${baseUrl}/book/getbookingtransaction/${id}`,
            {
                headers: {
                    authorization: token
                }
            }
        );
        // console.log("transaction listss", response.data.data);
        return response.data.data;
    }
);

export const getBuyerPayment = createAsyncThunk("getBuyerPayment", async () => {
    const response = await axios.get(
        `${baseUrl}/propertypayment/emipaidhistorybyadmin`,
        {
            headers: {
                authorization: token
            }
        }
    );
    // console.log("buyer payment history",response.data.data)
    return response.data.data;
});

export const getPaymentRefundRequest = createAsyncThunk(
    "getPaymentRefundRequest",
    async () => {
        const response = await axios.get(`${baseUrl}/refund/getRefundRequest`, {
            headers: {
                authorization: token
            }
        });
        // console.log("refund payment history",response.data.allData)
        return response.data.allData;
    }
);

export const getPropertyTransactionEMIList = createAsyncThunk(
    "getPropertyTransactionEMIList",
    async id => {
        const response = await axios.get(
            `${baseUrl}/propertypayment/getwithdrawalrequests`,
            {
                headers: {
                    authorization: token
                }
            }
        );
        // console.log("Property Transaction EMI",response.data.data)
        return response.data.data;
    }
);

export const getAgentPayment = createAsyncThunk("getAgentPayment", async () => {
    const response = await axios.get(`${baseUrl}/agentrelease/getadminlist`, {
        headers: {
            authorization: token
        }
    });
    //  console.log('Agent Payment',response.data)
    return response.data.data;
});

export const getPaymentwidtdrawalreq = createAsyncThunk(
    "getPaymentwidtdrawalreq",
    async () => {
        const responce = await axios.get(
            `${baseUrl}/propertypayment/releasepayment`,
            {
                headers: {
                    authorization: token
                }
            }
        );
        // console.log('Payment Release',responce.data.data)
        return responce.data.data;
    }
);

const transactionSlice = createSlice({
    name: "transactiosData",

    initialState: {
        filteredUsers: [],
        pennyTransactions: [],
        bookingTransactions: [],
        RefundTransactions: [],
        PropertyTransactionEMI: [],
        buyerData: [],
        AgentData: [],
        Releasepayment: [],
        selectedTransaction: {},
        transactionById: {},
        status: "",
        error: ""
    },

    reducers: {
        setFilterItems: (state, action) => {
            state.filteredUsers = action.payload;
        }
    },

    extraReducers(builder) {
        // get Penny Transactions
        builder
            .addCase(getPennyTransactionList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPennyTransactionList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.pennyTransactions = action.payload;
            })
            .addCase(getPennyTransactionList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })

            // get booking transaction
            .addCase(getBookingTransactionList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getBookingTransactionList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.bookingTransactions = action.payload;
            })
            .addCase(getBookingTransactionList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })

            // get refund transaction

            .addCase(getPaymentRefundRequest.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPaymentRefundRequest.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.RefundTransactions = action.payload;
            })
            .addCase(getPaymentRefundRequest.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })

            .addCase(getPropertyTransactionEMIList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(
                getPropertyTransactionEMIList.fulfilled,
                (state, action) => {
                    state.status = "succeeded";
                    state.PropertyTransactionEMI = action.payload;
                }
            )
            .addCase(
                getPropertyTransactionEMIList.rejected,
                (state, action) => {
                    state.status = "failed";
                    state.error = action.error.message;
                }
            )

            // get buyer payment
            .addCase(getBuyerPayment.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getBuyerPayment.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.buyerData = action.payload;
            })
            .addCase(getBuyerPayment.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })

            // get agent payment
            .addCase(getAgentPayment.pending, (state, action) => {
                state.status = "loadig";
            })
            .addCase(getAgentPayment.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.AgentData = action.payload;
            })
            .addCase(getAgentPayment.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            })

            // get release Payment;
            .addCase(getPaymentwidtdrawalreq.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPaymentwidtdrawalreq.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.Releasepayment = action.payload;
            })
            .addCase(getPaymentwidtdrawalreq.rejected, (state, action) => {
                state.status = "error";
                state.error = action.error.message;
            });
    }
});

export const { setFilterItems } = transactionSlice.actions;
export default transactionSlice.reducer;
